import React, { useEffect } from 'react';

const getHref = (link) => {
  const item = Array.isArray(link) ? link[0] : link;
  if (!item) return '#';
  const url = item['@id'] || '#';
  const isFile = item['@type'] === 'File';
  return isFile ? `${url}/@@download/file` : url;
};

const View = (props) => {
  const { data, properties = {} } = props;
  useEffect(() => {
    if (
      data?.showPublicationDate &&
      document?.body?.classList?.contains('contenttype-news-item')
    ) {
      document.body.classList.add('publication-date-visible');
      return () => {
        document.body.classList.remove('publication-date-visible');
      };
    }
  }, [data?.showPublicationDate]);

  const rawId = data?.backgroundVideo?.[0]?.['@id'] || '';
  const filename = rawId.split('/').filter(Boolean).pop();
  const isAlreadyDownloadUrl = rawId.includes('/@@download/');
  const videoUrl = rawId && filename
    ? (isAlreadyDownloadUrl ? rawId : `${rawId}/@@download/file/${filename}`)
    : null;

  const pageTitle = properties?.title || '';
  const pageDescription = properties?.description || '';
  const displayTitle = data.usePageTitle ? pageTitle : data.title;
  const displaySubtitle = data.usePageDescription ? pageDescription : data.subtitle;

  const publicationDate = data.showPublicationDate ? properties?.effective : null;
  const formattedDate = publicationDate ? new Date(publicationDate).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric'
  }) : null;

  const image = data.backgroundImage?.[0];
  const baseUrl = properties?.['@id'] || '';
  const previewImageUrl = `${baseUrl}/@@images/preview_image`;
  const defaultImageUrl = `${baseUrl}/@@images/image`;
  let imageUrl = '';
  if (data.usePreviewImage) {
    imageUrl = properties?.has_preview_image ? previewImageUrl : defaultImageUrl;
  } else {
    imageUrl = image ? `${image['@id']}/@@images/image` : '';
  }

  const alignment = data.alignment || 'left';

  const blocks = properties.blocks || {};
  const blocks_layout = properties.blocks_layout || {};
  const tocEntries = [];

  if (data.useTOC) {
    blocks_layout.items.forEach((blockId) => {
      const block = blocks[blockId];
      if (block?.['@type'] === 'slate') {
        const value = block.value || [];
        value.forEach((node) => {
          const type = node.type;
          
          const allowH2 = data.useH2 ?? true;
          const allowH3 = data.useH3 ?? true;
          const allowedTypes = [
            ...(allowH2 ? ['heading-two', 'h2'] : []),
            ...(allowH3 ? ['heading-three', 'h3'] : []),
          ];
          if (allowedTypes.includes(type)) {
            const text = node.children?.map((child) => child.text).join('').trim();
            const anchor = text.toLowerCase().replace(/[^a-z0-9]+/g, '-');
            tocEntries.push({ title: text, id: anchor });
          }
        });
      }
    });
  }

  return (
    <div className={`custom-hero-block ${data.isFullWidth ? 'full-width' : ''}`}>
      {videoUrl ? (
        <video
          className="hero-video-bg"
          autoPlay
          muted
          loop
          playsInline
          poster={imageUrl}
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      ) : (
        <div
          className="hero-image-bg"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
      )}
      <div className="overlay" />
      <div className={`custom-hero-inner align-${alignment}`}>
        <div className="custom-hero-content">
          {data.showPublicationDate && formattedDate && <div className="hero-date">{formattedDate}</div>}
          {displayTitle && <h1>{displayTitle}</h1>}
          {displaySubtitle && <h3>{displaySubtitle}</h3>}
        </div>
        {(data.useTOC ? tocEntries.length > 0 : data.buttons?.length > 0) && (
          <div className={`custom-hero-buttons${data.smallButtons ? ' small-buttons' : ''}`}>
            {data.useTOC
              ? tocEntries.map((entry, i) => (
                  <a key={i} href={`#${entry.id}`} className="hero-button">
                    {entry.title}
                  </a>
                ))
              : data.buttons.map((btn, i) => {
                  const href = getHref(btn.link);
                  const isExternal = (() => {
                    try {
                      const url = new URL(href, window.location.origin);
                      return url.hostname !== window.location.hostname;
                    } catch {
                      return false;
                    }
                  })();
                  return (
                    <a
                      key={i}
                      href={href}
                      className="hero-button"
                      {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                    >
                      {btn.label || 'Click here'}
                    </a>
                  );
                })}
          </div>
        )}
      </div>
    </div>
  );
};

export default View;
